module.exports = __webpack_public_path__ + "static/media/font_regular.a0d6db73.woff2";